import { Countdown } from '@app/components/countdown';
import { socialExportPublishMessages } from '@app/modules/social-export/publish';
import { Alert, Box, Checkbox, FormControlLabel } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';

export function SocialPublishAtField() {
  const { $t } = useIntl();
  const { control, setValue } = useFormContext();
  const publishAt = useWatch({ control, name: 'publishAt' });
  const publishImmediately = publishAt === null || publishAt === undefined;

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={publishImmediately}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setValue('publishAt', null);
              } else {
                // Set a default future date (1 hour from now) when unchecking
                const futureDate = new Date();
                futureDate.setHours(futureDate.getHours() + 1);
                setValue('publishAt', futureDate.toISOString());
              }
            }}
          />
        }
        label={$t({
          id: 'socialExport.form.publishImmediately',
          defaultMessage: 'Publicar inmediatamente',
        })}
      />
      {!publishImmediately && (
        <Box my={1}>
          <Controller
            name="publishAt"
            control={control}
            render={({ field, fieldState }) => {
              const minDateTime = DateTime.now().plus({ minutes: 2 });

              return (
                <DateTimePicker
                  label={$t({
                    id: 'socialExport.form.publishDateLabel',
                    defaultMessage: 'Fecha y hora de publicación',
                  })}
                  value={field.value ? DateTime.fromISO(field.value) : null}
                  onChange={(newValue: DateTime | null) => {
                    field.onChange(newValue?.isValid ? newValue.toISO() : null);
                  }}
                  minDateTime={minDateTime}
                  slotProps={{
                    textField: {
                      error: !!fieldState.error,
                      helperText: fieldState.error?.message,
                      fullWidth: true,
                    },
                  }}
                />
              );
            }}
          />
          <Countdown value={publishAt} />
        </Box>
      )}
      <Alert severity="info" sx={{ mt: 2 }}>
        {$t(socialExportPublishMessages.postPublishProcessingNotice)}
      </Alert>
    </Box>
  );
}
